(() => {
  const script = document.currentScript;
  const main = document.querySelector('main');
  if (!script || !main) return;
  const root = script.dataset.cpRoot.replace(/\/$/, '');
  const hosts = new Set([location.hostname, 'conferenceposters.ca', 'conferenceposters.com', 'www.conferenceposters.ca', 'www.conferenceposters.com', 'conferenceposters.myshopify.com']);
  const repair = () => {
    main.querySelectorAll('a[href]').forEach(link => {
      let url;
      try { url = new URL(link.getAttribute('href'), location.origin); } catch { return; }
      if (!hosts.has(url.hostname)) return;
      const path = url.pathname.replace(/^\/en-us(?=\/)/, '').replace(/\/$/, '');
      let target;
      if (path === '/pages/order-free-material-samples') target = root + path;
      if (path === '/pages/contact' || path === '/pages/contact-us') target = root + '/pages/contact-us';
      if (!target) return;
      target += url.search + url.hash;
      if (link.getAttribute('href') !== target) link.setAttribute('href', target);
    });
  };
  repair();
  new MutationObserver(repair).observe(main, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
})();
